<template>
  <simplebar class="custom-scrollbar-wrapper" data-simplebar-auto-hide="false" ref="scroller">
    <slot></slot>
  </simplebar>
</template>

<script lang="ts" setup>
  import simplebar from "simplebar-vue";
  import "simplebar-vue/dist/simplebar.min.css";
  import { onMounted, defineEmits, ref } from "vue";

  const emit = defineEmits(["scrollerComponent"]);
  const scroller = ref<typeof simplebar>();

  onMounted(() => {
    emit("scrollerComponent", scroller);
    scroller.value?.SimpleBar.el?.classList.remove("load");
  });
</script>
